export default "__VITE_ASSET__25da6fd6__"